import React from 'react';
import { Box, Fade, useTheme } from '@mui/material';
import { useReducedMotion } from '../hooks/useReducedMotion';

interface AnimatedTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const AnimatedTabPanel: React.FC<AnimatedTabPanelProps> = ({ children, value, index }) => {
  const theme = useTheme();
  const reduceMotion = useReducedMotion();
  const active = value === index;

  return (
    <div role="tabpanel" hidden={!active}>
      {active && (
        <Fade in timeout={reduceMotion ? 0 : theme.motion.duration.base}>
          <Box sx={{ p: 3 }}>{children}</Box>
        </Fade>
      )}
    </div>
  );
};

export default AnimatedTabPanel;
